module.exports = __webpack_public_path__ + "img/modal-el-lock.33a9a842.svg";